module.exports = __webpack_public_path__ + "static/male01-576d314983c27621ebb8c361a4bfa709.png";